import { Icon, IconBackground } from '@branch-messenger/willow-ui'
import { CreditCard02, SlashCircle01 } from '@branch-messenger/willow-ui/icons'

import AppIcon from '@/assets/icons/app_icon_rounded.svg?react'
import { SidebarMenuProps } from '@/components/sidebar'
import { useAccountActions } from '@/containers/payouts/hooks/useAccountActions'
import { useOrg } from '@/selectors/organization'
import { PaymentType } from '@/types/profile'

type SidebarMenuItems = Record<PaymentType, SidebarMenuProps['menuItems']>

export const useSidebarMenuItems = (): SidebarMenuItems | undefined => {
  const {
    data: { orgInfo },
  } = useOrg()
  const { switchToWallet, disableInstantPay, switchToDebitCard } =
    useAccountActions()

  if (!orgInfo?.supported_payment_types) {
    return
  }

  const walletSupported = orgInfo.supported_payment_types.includes('WALLET')
  const directCardSupported =
    orgInfo.supported_payment_types.includes('DIRECT_CARD')

  // TODO: can we consolidate these at all?
  return {
    CARD: [
      ...(walletSupported
        ? [
            {
              title: `Switch to the ${orgInfo.app_display_name} app`,
              description: 'Get paid quickly without fees.',
              iconLeft: <AppIcon width={40} height={40} />,
              onClick: switchToWallet,
            },
          ]
        : []),
      {
        title: 'Turn off payouts',
        description: 'I no longer wish to receive fast payouts.',
        onClick: disableInstantPay,
        iconLeft: (
          <IconBackground>
            <Icon Icon={SlashCircle01} size={6} />
          </IconBackground>
        ),
      },
    ],
    WALLET: [
      ...(directCardSupported
        ? [
            {
              title: 'Switch to debit card',
              description: 'Get paid quickly for a small fee.',
              onClick: switchToDebitCard,
              iconLeft: (
                <IconBackground>
                  <Icon Icon={CreditCard02} size={6} />
                </IconBackground>
              ),
            },
          ]
        : []),
      {
        title: 'Turn off payouts',
        description: 'I no longer wish to receive fast payouts.',
        onClick: disableInstantPay,
        iconLeft: (
          <IconBackground>
            <Icon Icon={SlashCircle01} size={6} />
          </IconBackground>
        ),
      },
    ],
    NONE: [
      ...(walletSupported
        ? [
            {
              title: `Get payouts to the ${orgInfo.app_display_name} app`,
              description: 'Get paid without fees.',
              onClick: switchToWallet,
              iconLeft: <AppIcon width={40} height={40} />,
            },
          ]
        : []),
      ...(directCardSupported
        ? [
            {
              title: 'Get payouts to your debit card',
              description: 'Get paid to an existing account for a small fee.',
              onClick: switchToDebitCard,
              iconLeft: (
                <IconBackground>
                  <Icon Icon={CreditCard02} size={6} />
                </IconBackground>
              ),
            },
          ]
        : []),
    ],
  }
}
